import { useListView } from '../../core/ListViewProvider'
import { UnidadesListGrouping } from './UnidadesListGrouping'
import { UnidadesListSearchComponent } from './UnidadesListSearchComponent'
import { UnidadesListToolbar } from './UnidadesListToolbar'

export const UnidadesListHeader = () => {
  const { selected } = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <UnidadesListSearchComponent
        actions={selected.length > 0 ? <UnidadesListGrouping /> : <UnidadesListToolbar />}
      />
    </div>
  )
}
